export default "__VITE_ASSET__C5oFt7sJ__"